module.exports = __webpack_public_path__ + "static/pvc-underground-conduits-de334cdcc8108a07341328ebf07ad4de.jpg";